import script from "./ManutAlertasTabPage.vue?vue&type=script&setup=true&lang=js"
export * from "./ManutAlertasTabPage.vue?vue&type=script&setup=true&lang=js"

import "./ManutAlertasTabPage.vue?vue&type=style&index=0&id=1c0be49a&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1c0be49a"]])

export default __exports__